import React from "react";
import store from "./state/store";
import { httpRequest } from "./services/http";
import PathogenicityPill from "./components/atoms/PathogenicityPill/PathogenicityPill";
import localStorageActions from "./common/helpers/localStorageActions";
import setMetaTags from "./common/helpers/metaSetter";
import { getInitialData } from "./state/actions/getInitialData";
import { setError } from "./state/actions/setError";
import Expander from "./components/Expander";
import {
  getCitation,
  pluralize,
  renderReviewStarsString,
  setStorageQuery,
  sanitizer,
} from "./common/helpers/helpers";
import { apiUrl, varsomeHostUrl } from "./common/helpers/Urls";
import { CATEGORIES, CATEGORIES_LIST } from "./pages/search-results/constants";
import goToLinkInternally from "./common/helpers/goToLinkInternally";
import GeneWithRefGenomeLink from "./common/helpers/GeneWithRefGenomeLink";
import { gray60 } from "./common/helpers/colors";
import HelperText from "./components/atoms/HelperText";

/* eslint-disable */

export default class LandingPage extends React.Component {
  constructor() {
    super();
    this.state = CATEGORIES_LIST.reduce((a, i) => ({ ...a, [i]: true }), {});
  }

  componentDidMount() {
    const l = decodeURIComponent(location.pathname);
    const match = l.match(/^\/([a-zA-Z-]+)\/(\d+)$/i);

    if (match) {
      getInitialData(this, this.getLandingPage, [match[1], match[2]]);
    } else {
      setError("Not found");
    }
  }

  getLandingPage(object_type, object_id) {
    this.setState({ isLoading: true });
    const state = store.getState();
    let queryId = localStorageActions.getQueryId(window.location.href);
    queryId = queryId ? `?t=${queryId}` : "";
    const url = `${apiUrl}/landing_page/${object_type}/${object_id}${queryId}`;
    httpRequest
      .get(url)
      .then((response) => {
        // Normalize the result
        // e.g pubmed landing pages contain 'variants' instead of 'referenced_by'
        const result = response.data;
        if (Object.prototype.hasOwnProperty.call(result, "variants")) {
          const references = result.referenced_by;
          references.variant = result.variants.map((v) => {
            v.object_type = "variant";
            return v;
          });
          references.reference_counts.variant = result.variants.length;
          references.reference_counts.total += result.variants.length;
          result.references = references;
        }
        if (object_type === "varsome-pubmed") {
          result.hpo = [{ source: "community" }];
          result.diseases = result.json_data.diseases || [];
          result.phenotypes = result.json_data.phenotypes || [];
          result.hpo[0].diseases = result.diseases;
          result.hpo[0].phenotypes = result.phenotypes;
        }
        setMetaTags(object_type, null, state.query, null, result);
        this.setState({ result, isLoading: false });
      })
      .catch((error) => {
        setError(`Error fetching ${object_type} data`);
        setError(error);
      });
  }

  setFilter(cat) {
    const { state } = this;
    // reset all to hidden
    for (let i = 0; i < CATEGORIES_LIST.length; i++) {
      const categ = CATEGORIES_LIST[i];
      state[categ] = false;
    }
    // and enable requested
    state[cat] = true;
    this.setState(state);
  }

  enableAllCategories() {
    const { state } = this;
    // reset all to hidden
    for (let i = 0; i < CATEGORIES_LIST.length; i++) {
      const categ = CATEGORIES_LIST[i];
      state[categ] = true;
    }
    this.setState(state);
  }

  renderReference(res) {
    if (res.object_type === "gene") {
      const { gene_symbol: geneSymbol, name } = res;
      const url = `${varsomeHostUrl}/gene/${geneSymbol}`;
      return (
        <div>
          <div className="search-result-label">Gene</div>
          <div className="search-result-content">
            <GeneWithRefGenomeLink
              onMouseDown={setStorageQuery.bind(this, url)}
              // onClick={goToLinkInternally.bind(this, url)}
              goInternally={true}
              href={url}
            >
              <span dangerouslySetInnerHTML={{ __html: geneSymbol }} />
            </GeneWithRefGenomeLink>
            {"  "}
            <span dangerouslySetInnerHTML={{ __html: name }} />
          </div>
        </div>
      );
    }
    if (res.object_type === "disease") {
      const { disease_name, object_id: objectId } = res;
      const url = `${varsomeHostUrl}/disease/${objectId}`;
      return (
        <div>
          <div className="search-result-label">Disease</div>
          <div className="search-result-content">
            <a
              onMouseDown={setStorageQuery.bind(this, url)}
              onClick={goToLinkInternally.bind(this, url)}
              href={url}
            >
              <span dangerouslySetInnerHTML={{ __html: disease_name }} />
            </a>
          </div>
        </div>
      );
    }
    if (res.object_type === "phenotype") {
      const { phenotype_name, object_id: objectId } = res;
      const url = `${varsomeHostUrl}/phenotype/${objectId}`;
      return (
        <div>
          <div className="search-result-label">Phenotype</div>
          <div className="search-result-content">
            <a
              onMouseDown={setStorageQuery.bind(this, url)}
              onClick={goToLinkInternally.bind(this, url)}
              href={url}
            >
              <span dangerouslySetInnerHTML={{ __html: phenotype_name }} />
            </a>
          </div>
        </div>
      );
    }
    if (res.object_type === "article") {
      const {
        title,
        object_id: objectId,
        authors,
        date_published: date,
        journal,
      } = res;
      const url = `${varsomeHostUrl}/article/${objectId}`;
      return (
        <div>
          <div className="search-result-label">Article</div>
          <div className="search-result-content">
            <a
              onMouseDown={setStorageQuery.bind(this, url)}
              onClick={goToLinkInternally.bind(this, url)}
              href={url}
            >
              <span dangerouslySetInnerHTML={{ __html: title || "-" }} />
            </a>
            <div className="varsome-text-muted" style={{ fontSize: "0.8rem" }}>
              {getCitation(authors, date, journal)}
            </div>
          </div>
        </div>
      );
    }
    if (res.object_type === "ClinVar entry") {
      const { object_id: objectId } = res;
      const url = `${varsomeHostUrl}/variant/${objectId}`;
      return (
        <div>
          <div className="search-result-label">ClinVar entry</div>
          {res["NCBI ClinVar2"] &&
            res["NCBI ClinVar2"].map((result, i) => {
              const {
                clinical_significance: clinicalSignificance,
                review_stars: reviewStars,
                acmg_class: acmgClass,
                pretty_text: prettyText,
              } = result;
              return (
                <div className="search-result-content" key={i}>
                  <a
                    onMouseDown={setStorageQuery.bind(this, url)}
                    onClick={goToLinkInternally.bind(this, url)}
                    href={url}
                  >
                    {prettyText}
                  </a>
                  <span className="tw-ml-4 tw-text-sm">
                    <PathogenicityPill pathogenicity={acmgClass} />
                    {` (${clinicalSignificance}) [`}
                    <span
                      dangerouslySetInnerHTML={{
                        __html: renderReviewStarsString(reviewStars),
                      }}
                    />
                    ]
                  </span>
                </div>
              );
            })}
        </div>
      );
    }
    if (res.object_type === "UniProt variant") {
      const { object_id: objectId } = res;
      const url = `${varsomeHostUrl}/variant/${objectId}`;
      return (
        <div>
          <div className="search-result-label">UniProt variant</div>
          {res["UNIPROT UniProt Variants"] &&
            res["UNIPROT UniProt Variants"].map((result, i) => {
              const {
                diseases,
                acmg_class: acmgClass,
                pretty_text: prettyText,
                protein_id: proteinId,
              } = result;
              return (
                <div className="search-result-content" key={i}>
                  <a
                    onMouseDown={setStorageQuery.bind(this, url)}
                    onClick={goToLinkInternally.bind(this, url)}
                    href={url}
                  >
                    {prettyText}
                  </a>
                  <span className="tw-text-sm tw-ml-4">
                    <PathogenicityPill pathogenicity={acmgClass} />
                    {"  "}
                    {Array.isArray(diseases) && (
                      <span>
                        (
                        {diseases.map((d, i) => (
                          <span key={i}>
                            {d}
                            {i < diseases.length - 2 && ", "}
                          </span>
                        ))}
                        )
                      </span>
                    )}
                    {" [protein: "}
                    {proteinId}]
                  </span>
                </div>
              );
            })}
        </div>
      );
    }
    if (res.object_type === "VarSome comment") {
      const {
        variant_id: variantId,
        comment,
        error,
        pathogenicity,
        pretty_text: prettyText,
      } = res;
      const { showErrorText } = this.state;
      const url = `${varsomeHostUrl}/variant/${variantId}`;
      return (
        <div>
          <div className="search-result-label">VarSome user classification</div>
          <div
            className="search-result-content tw-ml-4"
            style={{ fontSize: "0.9rem" }}
          >
            <a
              onMouseDown={setStorageQuery.bind(this, url)}
              onClick={goToLinkInternally.bind(this, url)}
              href={url}
            >
              {prettyText}
            </a>
            {pathogenicity && (
              <span className="tw-ml-8">
                <PathogenicityPill pathogenicity={pathogenicity} />
              </span>
            )}
            {comment && (
              <div>
                <strong>Comment: </strong>
                {comment}
              </div>
            )}
          </div>
          {showErrorText && <div className="search-result-error">{error}</div>}
        </div>
      );
    }
    if (res.object_type === "VarSome PubMed") {
      const { object_id: objectId, pub_med: pubMed, comment, variants } = res;
      const { showErrorText } = this.state;
      const url = `${varsomeHostUrl}/varsome-pubmed/${objectId}`;
      return (
        <div>
          <div className="search-result-label">
            VarSome user publication
            {showErrorText && `: ${objectId}`}
          </div>
          <a
            onMouseDown={setStorageQuery.bind(this, url)}
            onClick={goToLinkInternally.bind(this, url)}
            href={url}
          >
            View here
          </a>
          <div className="search-result-content">
            {pubMed && (
              <div style={{ fontSize: "0.9rem" }}>
                Article:
                {"  "}
                <span>{pubMed.title}</span>
              </div>
            )}
            {comment && (
              <div style={{ fontSize: "0.9rem" }}>
                Comment:
                {"  "}
                <span
                  dangerouslySetInnerHTML={{
                    __html: sanitizer.sanitizeAllowNoTags(comment),
                  }}
                />
              </div>
            )}
            {variants && (
              <div style={{ fontSize: "0.9rem" }}>
                Associated variants:&nbsp;
                <Expander component="span" showMore="3">
                  {variants.map((v, i) => {
                    const url = `${varsomeHostUrl}/variant/${v.variant_id}`;
                    return (
                      <span key={i}>
                        <span>
                          <a
                            onMouseDown={setStorageQuery.bind(this, url)}
                            onClick={goToLinkInternally.bind(this, url)}
                            href={url}
                          >
                            {v.pretty_text}
                          </a>
                          {v.pathogenicity && (
                            <span style={{ marginLeft: "0.3rem" }}>
                              <PathogenicityPill
                                pathogenicity={v.pathogenicity}
                              />
                            </span>
                          )}
                        </span>
                        {i < variants.length - 1 && ", "}
                      </span>
                    );
                  })}
                </Expander>
              </div>
            )}
          </div>
        </div>
      );
    }
    if (res.object_type === "variant" || res.object_type === "Variant") {
      const {
        variant_id: variantId,
        pretty_text: prettyText,
        pathogenicity,
        error,
      } = res;
      const { showErrorText } = this.state;
      const url = `${varsomeHostUrl}/variant/${variantId}`;
      return (
        <div>
          <div className="search-result-label">Variant</div>
          <div className="search-result-content">
            <a
              onMouseDown={setStorageQuery.bind(this, url)}
              onClick={goToLinkInternally.bind(this, url)}
              href={url}
            >
              {prettyText}
            </a>
            {pathogenicity && (
              <span className="tw-ml-4">
                <PathogenicityPill pathogenicity={pathogenicity} />
              </span>
            )}
          </div>
          {showErrorText && <div className="search-result-error">{error}</div>}
        </div>
      );
    }
    const url = `${varsomeHostUrl}/${res.object_type}/${res.object_id}`;
    return (
      <div>
        <div className="search-result-label">{res.object_type}</div>
        <div className="search-result-content">
          <a
            onMouseDown={setStorageQuery.bind(this, url)}
            onClick={goToLinkInternally.bind(this, url)}
            href={url}
          >
            {res.object_id}
          </a>
        </div>
      </div>
    );
  }

  renderReferences(references) {
    let tmpl = null;

    const referencesRes = [];
    const categories = [];
    const allEnabled = CATEGORIES_LIST.every((c) => {
      const category = this.state[c];
      return category === true;
    });
    if (references.reference_counts && references.reference_counts.total > 0) {
      // Number of categories in results (-1 because of `reference_counts` key)
      const numCats = references ? Object.keys(references).length - 1 : 0;
      // Keep track of how many are rendered, so we can add a comma between
      let counter = 0;
      for (let i = 0; i < CATEGORIES_LIST.length; i++) {
        const cat = CATEGORIES_LIST[i];
        if (Object.prototype.hasOwnProperty.call(references, cat)) {
          const count = references.reference_counts[cat];
          if (allEnabled) {
            categories.push(
              <span key={counter}>
                {`${count} `}
                <a onClick={this.setFilter.bind(this, cat)}>
                  {pluralize(
                    count,
                    CATEGORIES[cat].single || cat,
                    CATEGORIES[cat].plural || cat
                  )}
                </a>
              </span>
            );
            counter += 1;
            if (counter < numCats) {
              categories.push(<span key={`${counter} ,`}>, </span>);
            }
          } else if (this.state[cat]) {
            categories.push(
              <span key={counter}>
                {"Showing only "}
                <strong>{cat}</strong>
                {" references. "}
                <a onClick={this.enableAllCategories.bind(this)}>
                  Remove filter and view all references.
                </a>
              </span>
            );
          }
        }

        // If enabled render the references
        if (
          this.state[cat] &&
          Object.prototype.hasOwnProperty.call(references, cat)
        ) {
          const arr = references[cat];
          referencesRes.push(
            <div key={cat}>
              {arr.map((res, i) => {
                return (
                  <div className="search-result" key={i}>
                    {this.renderReference(res)}
                  </div>
                );
              })}
              {arr.length > 99 && (
                <div className="tw-ml-4">
                  <small style={{ color: gray60 }}>
                    {"Only the first "}
                    {arr.length}
                    {" items for "}
                    {cat}
                    {" are displayed "}
                  </small>
                </div>
              )}
            </div>
          );
        }
      }

      tmpl = (
        <div className="varsome-result">
          <div className="varsome-container">
            <div className="varsome-title">
              {`Referenced by ${references.reference_counts.total} `}
              {pluralize(references.reference_counts.total, "item", "items")}
              {"  "}
              <HelperText
                title={"References"}
                fieldDescriptionKey={"References"}
              />
            </div>
            <div className="varsome-inner-container">
              <div className="tw-mb-4">{categories}</div>
              {referencesRes}
            </div>
          </div>
        </div>
      );
    } else {
      tmpl = (
        <div className="varsome-result">
          <div className="varsome-container">
            <div className="varsome-title">
              {`Referenced by ${references.reference_counts.total} `}
              {pluralize(references.reference_counts.total, "item", "items")}
              {"  "}
              <HelperText
                title={"References"}
                fieldDescriptionKey={"References"}
              />
            </div>
            <div className="varsome-inner-container">No references found.</div>
          </div>
        </div>
      );
    }

    return tmpl;
  }
}
